var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.19 18.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_320",
    "data-name": "Pfad 320",
    d: "M15.41,2.92h-4V2.5A2.5,2.5,0,0,0,8.93,0H7.26a2.5,2.5,0,0,0-2.5,2.5v.42h-4a.78.78,0,0,0,0,1.56h.46l1.1,12.08A2.24,2.24,0,0,0,4.58,18.8h7a2.21,2.21,0,0,0,2.23-2.17L15,4.48h.46a.78.78,0,1,0,0-1.56ZM6.31,2.5a1,1,0,0,1,1-.95H8.93a1,1,0,0,1,1,1v.42H6.31Zm6,14.06a.69.69,0,0,1-.69.69h-7a.71.71,0,0,1-.69-.73v0l-1.1-12h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_321",
    "data-name": "Pfad 321",
    d: "M8.09,6.6a.6.6,0,0,0-.6.6v7.32a.61.61,0,1,0,1.21,0V7.2a.6.6,0,0,0-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_322",
    "data-name": "Pfad 322",
    d: "M10,7.2v7.32a.61.61,0,1,0,1.21,0V7.2A.61.61,0,0,0,10,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_323",
    "data-name": "Pfad 323",
    d: "M5.61,6.6a.6.6,0,0,0-.6.6v7.32a.61.61,0,1,0,1.21,0V7.2a.6.6,0,0,0-.6-.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.0f1cc755fbb2c0310eb4949ff3e06693.svg";
export { ForwardRef as ReactComponent };